<template>
  <div class="box-shadow">
  <form>
    <div class="">
        <h4 class="heading">Account Details</h4>
        <div class="row">
          <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.account_number')}">
            <label>Account Number</label><span class="message">{{ validation.firstError('formInput.account_number') }}</span>
            <vue-bootstrap-typeahead
              ref="account_number"
              :data="customers"
              v-model="formInput.account_number"
              :serializer="customerFormattedDisplay"
              placeholder="Search Account No."
              @hit="setCustomerInfo"
            />
          </div>    
          <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.client_name')}">
            <label>Client Name</label><span class="message">{{ validation.firstError('formInput.client_name') }}</span>
            <input type="text" placeholder="Enter Client Name Here.." class="form-control" v-model="formInput.client_name" readonly>
          </div> 
        </div> 

        <div>
          <h4 class="heading">Transaction Details</h4>
          <div class="row">
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.type')}">
              <label>Type</label><span class="message">{{ validation.firstError('formInput.type') }}</span>
              <select name="type" ref="type" class="form-control" v-model="formInput.type">
                <option selected value="">Select Type</option>
                <option value="1">Deposit</option>
                <option value="2">Withdrawal</option>
              </select>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.value')}">
              <label>Value</label><span class="message">{{ validation.firstError('formInput.value') }}</span>
              <input type="text" ref="value" placeholder="Enter Quantity Here.." class="form-control" v-model="formInput.value">
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.currency')}">
              <label>Currency</label><span class="message">{{ validation.firstError('formInput.currency') }}</span>
              <vue-bootstrap-typeahead
                ref="currency"
                :data="currencies"
                v-model="formInput.currency"
                :serializer="CurrencyFormattedDisplay"
                placeholder="Search Currency"
                @hit="setCurrencyInfo"
              />
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.transaction_date')}">
              <label>Transaction Date (DD-MM-YYYY)</label><span class="message">{{ validation.firstError('formInput.transaction_date') }}</span><br>
              <date-picker input-class="form-control" ref="transaction_date" value-type="format" type="date" v-model="formInput.transaction_date" format='DD-MM-YYYY'></date-picker>
            </div>
            <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.comment')}">
              <label>Comment</label><span class="message">{{ validation.firstError('formInput.comment') }}</span>
              <textarea type="text" ref="comment" placeholder="Enter Comment Here.." class="form-control" v-model="formInput.comment"></textarea>
            </div>
          </div>
        </div>
      <input type="hidden" v-model="formInput.id"/>
      <div class="" style="display:flow-root">
        <button type="button" v-on:click="addTransaction" class="btn btn-lg btn-info pull-right">Submit</button>
      </div>       
    </div>
  </form>
  </div>
</template>

<script>
import Vue from 'vue';
import common from '@/assets/js/common.js';
import DatePicker from 'vue2-datepicker';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import moment from 'moment';
import 'vue2-datepicker/index.css';
import SimpleVueValidator from 'simple-vue-validator';

const Validator = SimpleVueValidator.Validator;
export default {
  name: 'AddCustomerForm',
  props:['rows', 'forceRerender'],
  mixins: [common,SimpleVueValidator.mixin],
  components: {DatePicker, VueBootstrapTypeahead},
  data(){
    return {
      customers: [],
      showDetailedForm: false,
      lessOrMore: "more",
      currencies: [],
      formInput:{
        'id':'',
        'action': 'create',
        'count': 0,
        'account_number': '',
        'client_name': '',
        'type': 1,
        'value': '',
        'currency':'GBP',
        'transaction_date': moment().format('DD-MM-YYYY'),
        'comment': '',
      }
    };
  },
  computed: {
    authHeaders () {
      return {
        'access-token': '7403f0291437c47e589fdd0445860f95'
      }
    },
  },
  validators: {
    'formInput.account_number': function(value) {
      return Validator.value(value).required();
    },
    'formInput.client_name': function(value) {
      return Validator.value(value).required();
    },
    'formInput.type': function(value) {
      return Validator.value(value).required();
    },
    'formInput.value': function(value) {
      return Validator.value(value).required().integer();
    },
    'formInput.currency': function(value) {
      return Validator.value(value).required();
    },
    'formInput.transaction_date': function(value) {
      return Validator.value(value).required().regex('^((0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])-([12]\\d{3}))$', 'Not in Valid Format: DD-MM-YYYY.');
    },
  },
  watch: {
    'formInput.account_number': function (input) {
      this.$refs.account_number.inputValue = input;
      this.getCustomer(input);
    },
    'formInput.currency': function (input) {
      this.$refs.currency.inputValue = input;
    },
  },
  methods: {
    async getCustomer(input) {
      const limit = 10, offset = 0, sort = '', order = '';
      var filter = {}; 
      filter['account_number'] = input;
      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      const {response} = await this.call_axios(uri);
      this.customers = response.data.result;
    },
    setCustomerInfo (group) {
      this.$refs.account_number.inputValue = group.account_number;
      this.formInput.account_number = group.account_number;
      this.formInput.client_name = (typeof group == "object") ? group.firstname+' '+(group.lastname ? group.lastname : "") : "" ;
    },
    customerFormattedDisplay (result) {
      return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
    },
    CurrencyFormattedDisplay (result) {
      return result.name+' ('+result.code+')';
    },
    setCurrencyInfo (group) {
      this.formInput.currency = (typeof group == "object") ? group.code : group;
      this.$refs.currency.inputValue = (typeof group == "object") ? group.code : group;
    },
    setShowDetailedForm: function(e){
      e.preventDefault();
      this.showDetailedForm = this.showDetailedForm?false:true;
      this.lessOrMore = this.showDetailedForm?"less":"more";
    },
    addTransaction(){
      this.$validate()
          .then(async (success) => {
            if (success) {
              const {response} = await this.call_axios('add_transaction', 'post', this.formInput);
              this.forceRerender(response);
            }
          });
    },
    async trade_init(){
      const {response} = await this.call_axios('trade_init_data');
      this.currencies = response.data.currencies;
    }
  },
  mounted(){
    this.$refs.currency.inputValue = this.formInput.currency;
  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
    this.trade_init();
  }
};
</script>

<style lang="scss">
.only-border-bottom{
  border-bottom: 1px solid !important;
  border: 0;
}
.bold{
  font-weight: bold;
}
.error .message{
  color: red;
  padding: 5px 5px;
}
.error .form-control, .error .autocomplete__box{
  border-color: red;
}
.mx-datepicker{
  width: 100%;
}
.heading{
  font-weight:600;
}
.input-group .w-40{
    width:40%;
}
.input-group .w-60{
    width:60%;
}
.vbt-autcomplete-list{
  background-color: #fff;
}
</style>
<style scoped>
.dl-horizontal dd {
    margin-left: 340px;
}
.dl-horizontal dt {
    width: 320px;
}
.input-group > .form-control, .input-group > .form-control-plaintext, .input-group > .custom-select, .input-group > .custom-file{
  flex: min-content;
}
</style>